module.exports = __webpack_public_path__ + "static/media/back-arrow.8f540615.svg";